<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Criar Permissão de Executor
      </p>
    </div>

    <div class="col-md-2 q-ml-sm q-mt-lg">
      <q-btn
        @click="rightDrawerModalOpen = true"
        icon="done"
        no-caps
        style="background-color: #21324a; border-radius: 8px; color: white"
        label="Criar Novo"
      />
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2">
          Unidade:

          <lista-unidades-select
            class="input-new-design"
            :todos="temPermissaoTodasUnidades"
            v-model="filtros.unidade"
          ></lista-unidades-select>
        </div>
        <div class="col-md-2 q-ml-sm">
          Usuário:

          <q-select
            outlined
            dense
            v-model="filtros.usuario"
            :options="listaUsuarios"
            class="input-new-design"
            option-value="id"
            label="Selecione o Usuario"
            behavior="menu"
            map-options
            emit-value
            use-input
            option-label="name"
            @filter="filterUser"
          >
          </q-select>
        </div>
        <div class="col-md-2 q-ml-sm">
          Tipo de Vínculo:
          <q-select
            v-model="filtros.resource"
            behavior="menu"
            option-label="label"
            option-value="value"
            class="input-new-design"
            :options="tipoVinculo"
            map-options
            use-input
            emit-value
            dense
            outlined
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Ação:

          <q-select
            v-model="filtros.acao"
            behavior="menu"
            :disable="filtros.resource == ''"
            class="input-new-design"
            :options="agrupadorAcao"
            option-label="label"
            option-value="value"
            map-options
            use-input
            emit-value
            dense
            outlined
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg">
          <q-btn
            @click="getDados()"
            icon="filter_alt"
            no-caps
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>
      </div>

      <!-- Modal: usuário sem permissão e sem unidade selecionada -->
      <dialog-info-design
        mensagem="Selecione uma Unidade para continuar"
        sub-mensagem="Por favor, selecione uma Unidade no filtro antes de prosseguir."
        :exibir="modalSelecioneUnidade"
        :esconder-confirme="true"
        :show-cancelar="true"
        @resultado="modalSelecioneUnidade = false"
      />

      <template v-if="temPermissaoTodasUnidades || filtros.unidade?.id">
        <q-table
          flat
          table-header-class="bg-accent text-width-bold q-mt-md"
          :rows="rows"
          :loading="disable"
          dense
          :columns="columns"
          v-model:pagination="pagination"
          class="tabela-tamanho-fixo q-mt-md"
          row-key="name"
          :rows-per-page-options="[0]"
          hide-pagination
          @request="handleRequest"
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;

                color: #21324a;
              "
            >
              Regras Criadas</span
            >
          </template>
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template #body-cell-remover="props">
            <q-td>
              <q-btn
                flat
                no-caps
                color="red"
                icon="sym_o_delete"
                @click="(confirmacao = true), (saveId = props.row)"
              />
            </q-td>
          </template>
        </q-table>
        <div v-if="false" class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </template>

      <Transition name="slide-fade">
        <q-card v-if="rightDrawerModalOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center justify-between">
              <div class="row">
                <q-icon
                  style="cursor: pointer"
                  name="close"
                  class="q-mr-md"
                  size="22px"
                  @click="rightDrawerModalOpen = false"
                />
                <span style="font-size: 16px">
                  <span>
                    <span>Criar Permissão</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <q-scroll-area class="teste" style="width: 100%; height: 92%">
            <div class="column col-12 no-wrap">
              <div class="q-px-md text-weight-bold">
                <div class="col-md-12 q-mt-xs">
                  Usuário:
                  <q-select
                    outlined
                    dense
                    v-model="criacaoDados.usuario"
                    :options="listaUsuarios"
                    class="input-new-design"
                    option-value="id"
                    label="Selecione o Usuario"
                    behavior="menu"
                    map-options
                    emit-value
                    use-input
                    option-label="name"
                    @filter="filterUser"
                  >
                  </q-select>
                </div>
                <div class="col-md-12 q-mt-sm">
                  Tipo de Vínculo:
                  <q-select
                    v-model="criacaoDados.resource"
                    behavior="menu"
                    option-label="label"
                    option-value="value"
                    class="input-new-design"
                    :options="tipoVinculo"
                    map-options
                    use-input
                    emit-value
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-sm">
                  Ação:

                  <q-select
                    v-model="criacaoDados.acao"
                    behavior="menu"
                    option-label="label"
                    option-value="value"
                    :disable="criacaoDados.usuario == ''"
                    class="input-new-design"
                    :options="agrupadorAcaoCriar"
                    map-options
                    use-input
                    emit-value
                    dense
                    outlined
                  />
                </div>
              </div>
              <div class="q-px-md q-mt-md q-pb-md">
                <q-btn
                  style="
                    background-color: #21324a;
                    border-radius: 8px;
                    color: white;
                    font-weight: normal;
                  "
                  label="Criar"
                  no-caps
                  icon="add"
                  :disable="criacaoDados.usuario == ''"
                  @click="criarRegra"
                />
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
      <dialog-confirm-design
        mensagem="Tem certeza que deseja excluir a Permissão"
        :exibir="confirmacao"
        @resultado="excluirRegra"
      />
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "unidade",
    label: "Unidade",
    field: (row) => row.vendorNome,
    align: "left",
  },
  {
    name: "acao",
    label: "Ação",
    field: (row) => row.acao,
    align: "left",
  },
  {
    name: "resource",
    label: "Resource",
    field: (row) => row.resource,
    align: "left",
  },
  {
    name: "usuario_nome",
    label: "usuarioNome",
    field: (row) => row.usuarioNome,
    align: "left",
  },
  {
    name: "usuario_perfil",
    label: "usuarioPerfil",
    field: (row) => row.usuarioPerfil,
    align: "left",
  },
  {
    name: "data_criacao",
    label: "Data de Criação",
    field: (row) =>
      row.criadoEm.date.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
  },

  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, computed, watch, onMounted } from "vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { usuarioTemPermissao } from "../../../../helpers/permissaoHelper";

export default {
  components: { ListaUnidadesSelect, DialogConfirmDesign, DialogInfoDesign },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const rightDrawerModalOpen = ref(false);
    const agrupadorAcao = ref([]);
    const agrupadorAcaoCriar = ref([]);
    const modalSelecioneUnidade = ref(false);
    const filtros = ref({
      resource: "",
      usuario: "",
      acao: "",
      unidade: "",
    });
    const confirmacao = ref(false);
    const saveId = ref(null);
    const criacaoDados = ref({
      resource: "",
      usuario: "",
      acao: "",
      unidade: "",
    });
    const time = ref(null);

    const listaUsuarios = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    // Computed que verifica se o usuário tem a permissão "visualizar_todas_unidades"
    const temPermissaoTodasUnidades = computed(() =>
      usuarioTemPermissao(store, "visualizar_todas_unidades")
    );

    const getDados = async (page = 1, rowsPerPage = 15) => {
      // Bloqueia a busca se o usuário não tem permissão e não selecionou uma unidade
      if (!temPermissaoTodasUnidades.value && !filtros.value.unidade?.id) {
        modalSelecioneUnidade.value = true;
        disable.value = false;
        return;
      }

      try {
        let response = await store.dispatch("user/getRegraExecutor", {
          usuarioId:
            filtros.value.usuario == "" ? undefined : filtros.value.usuario,
          vendorId:
            filtros.value.unidade?.id ||
            store.state.org.unidadeData?.id ||
            undefined,
          resource:
            filtros?.value?.resource == ""
              ? undefined
              : filtros?.value?.resource,
          acao: filtros?.value?.acao == "" ? undefined : filtros?.value?.acao,
          perPage: rowsPerPage,
          page,
        });

        const result = response.data.result;
        rows.value = Array.isArray(result)
          ? result
          : Array.isArray(result?.data)
          ? result.data
          : [];

        disable.value = false;
      } catch (error) {
        disable.value = false;
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(() => {
      if (store.state.org.unidadeData?.id) {
        filtros.value.unidade = store.state.org.unidadeData;
      }
      getDados();
    });

    const listarUsuarios = async (value) => {
      try {
        let response = await store.dispatch("user/getUsuarios", {
          vendor_id: store.state.org.unidadeData?.id,
          per_page: 10,
          search: value,
        });

        listaUsuarios.value = response.data.results.data;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarRegra = async () => {
      try {
        await store.dispatch("user/criarRegraExecutor", {
          usuarioId: criacaoDados.value.usuario,
          vendorId: store.state.org.unidadeData?.id,
          resource: criacaoDados.value.resource,
          acao: criacaoDados.value.acao,
        });

        getDados(pagination.value.page, pagination.value.rowsPerPage);
        quasar.notify({
          message: "Regra Criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        rightDrawerModalOpen.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o criar regra",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getTipo = async () => {
      try {
        switch (filtros.value.resource) {
          case "Vouchers":
            agrupadorAcao.value = [
              { label: "Criar", value: "create" },
              { label: "Editar Quantidade", value: "update-amount" },
              { label: "Cancelar", value: "cancel" },
              { label: "Rejeitar", value: "reject" },
              { label: "Finalizar", value: "finish" },
            ];

            break;
          case "NotaFiscal":
            agrupadorAcao.value = [
              { label: "Criar Manual", value: "create" },
              { label: "Finalizar", value: "finish" },
              { label: "Criar com XML", value: "create-from-xml" },
            ];

            break;
          case "Compras":
            agrupadorAcao.value = [
              { label: "Criar", value: "criar" },

              {
                label: "Associar Item na Necessidade",
                value: "vincular-item-necessidade",
              },
              {
                label: "Associar Item no Pedido",
                value: "vincular-item-necessidade-pedido",
              },
            ];

            break;
          case "Inventario":
            agrupadorAcao.value = [
              { label: "Criar Pedido", value: "criar" },
              { label: "Criar por Planilha", value: "criar-por-planilha" },
              { label: "Aprovar", value: "aprovar" },
              { label: "Aprovar Divergente", value: "aprovar-divergente" },
            ];

            break;
          case "Transferencia":
            agrupadorAcao.value = [
              { label: "Criar", value: "criar" },
              { label: "Enviar", value: "enviar" },
              { label: "Receber", value: "receber" },
            ];

            break;
          default:
        }
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar catalogos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getTipoCriar = async () => {
      try {
        switch (criacaoDados.value.resource) {
          case "Vouchers":
            agrupadorAcaoCriar.value = [
              { label: "Criar", value: "create" },
              { label: "Editar Quantidade", value: "update-amount" },
              { label: "Cancelar", value: "cancel" },
              { label: "Rejeitar", value: "reject" },
              { label: "Finalizar", value: "finish" },
            ];

            break;
          case "NotaFiscal":
            agrupadorAcaoCriar.value = [
              { label: "Criar Manual", value: "create" },
              { label: "Finalizar", value: "finish" },
              { label: "Criar com XML", value: "create-from-xml" },
            ];

            break;
          case "Compras":
            agrupadorAcaoCriar.value = [
              { label: "Criar", value: "criar" },

              {
                label: "Associar Item na Necessidade",
                value: "vincular-item-necessidade",
              },
              {
                label: "Associar Item no Pedido",
                value: "vincular-item-necessidade-pedido",
              },
            ];

            break;
          case "Inventario":
            agrupadorAcaoCriar.value = [
              { label: "Criar Pedido", value: "criar" },
              { label: "Criar por Planilha", value: "criar-por-planilha" },
              { label: "Aprovar", value: "aprovar" },
              { label: "Aprovar Divergente", value: "aprovar-divergente" },
            ];

            break;
          case "Transferencia":
            agrupadorAcaoCriar.value = [
              { label: "Criar", value: "criar" },
              { label: "Enviar", value: "enviar" },
              { label: "Receber", value: "receber" },
            ];

            break;
          default:
        }
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar catalogos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirRegra = async (resutado) => {
      confirmacao.value = false;
      if (resutado) {
        disable.value = true;
        try {
          await store.dispatch("user/deletarRegraExecutor", {
            id: saveId.value.uuid,
          });

          getDados(pagination.value.page, pagination.value.rowsPerPage);
          quasar.notify({
            message: "Regra excluida com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
        } catch (error) {
          disable.value = false;
          quasar.notify({
            message: "Erro a o excluir regra",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtros.value.resource,
      () => {
        getTipo();
      }
    );

    watch(
      () => criacaoDados.value.resource,
      () => {
        getTipoCriar();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      criarRegra,
      rightDrawerModalOpen,
      excluirRegra,
      criacaoDados,
      confirmacao,
      saveId,
      temPermissaoTodasUnidades,
      modalSelecioneUnidade,
      tipoVinculo: [
        { label: "Vouchers", value: "Vouchers" },
        { label: "Nota Fiscal", value: "NotaFiscal" },
        { label: "Compras", value: "Compras" },
        { label: "Inventário", value: "Inventario" },
        { label: "Transferência", value: "Transferencia" },
      ],
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,

      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      agrupadorAcao,
      agrupadorAcaoCriar,
      listaUsuarios,
      filterUser(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          listarUsuarios(val);
        }, 500);

        setTimeout(() => {
          update();
        }, 1000);
      },
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
<style scoped>
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 350px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.teste {
  z-index: 2;
  overflow: hidden;
}
</style>
